import React from 'react'
import { BLTNavigationTop } from '../BLTCommon/BLTNavigationTop'
import { saveSegueDetails } from '../../../redux/slice/primaryAgencyApplicationSlice'
import { APPLICATION_TYPE_BUSINESS_LICENCE_ADMIN, SEGUE_NAME } from '../../../app/constants'
import { Button } from "../../../components/RegularComponents"
import './BLTLogin.styles.scss'
import { useDispatch } from 'react-redux'
import { startNSLogin } from '../../../redux/slice/nsLoginSlice'

export default function BLTLoginPage() {

    const dispatch = useDispatch()

    // useEffect(() => { 
    //     if(nextUrl) { 
    //         dispatch(resetNextUrl())
    //         dispatch(push(nextUrl))
    //     }
    // })

    return (
        <>
            <BLTNavigationTop />

            <div className={"container topMarginLarge"}>
                <div className="row">
                    <div className="col-xs-8">
                        <h1 className="loginTitle">Business Licensing Service</h1>
                        <h2 className="loginInfo">Review and process applications and renewals for business licences.</h2>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-6">
                        <div className="loginContainer">

                            <h3 className="signInMessage">Sign in with your Nova Scotia login account</h3>

                            <div className="bottomMarginNormal">
                                <Button
                                    id="continue-to-ns-login-service-button"
                                    buttonType="regular_primary"
                                    text="Continue to Nova Scotia login service"
                                    onClick={() => {

                                        dispatch(saveSegueDetails({
                                            name: SEGUE_NAME.LOGIN,
                                            applicationType: APPLICATION_TYPE_BUSINESS_LICENCE_ADMIN
                                        }))

                                        dispatch(startNSLogin())
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}